import { isValidElement, type ReactElement, type ReactNode } from 'react'

export type DefaultContent = {
	header?: ReactNode
	body: ReactNode
	footer?: ReactNode
	isFocusTrapEnabled?: boolean
	isDismissable?: boolean
	onClosed?: () => void
}

export type DefaultContentRender = (props: { onClose: () => void }) => ReactElement | DefaultContent

export const normalizeDefaultContent = (content: ReactElement | DefaultContent): DefaultContent =>
	isValidElement<any>(content) ? { body: content } : content
